export default __webpack_public_path__ + "static/media/beverage-coffee-cup.feadefc4.jpg";